/* * @Author: Gang Jiang * @Date: 2024-11-25 15:25:01 * @Last Modified by: Gang
Jiang * @Last Modified time: 2025-03-12 09:48:01 */

<template>
  <div class="product" ref="zjdgx">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-shangpin"></use>
      </svg>
    </breadcrumbs>
    <a-spin :spinning="isLoadingList">
      <div class="content-wrapper">
        <LeftFilterPanel
          ref="leftFilterPanelRef"
          :filter="filter"
          :category-collapsed="categoryCollapsed"
          :brand-collapsed="brandCollapsed"
          :is-searching-brands="isSearchingBrands"
          :brand-search="brandSearch"
          :brands="brands"
          :is-loading-brands="isLoadingBrands"
          :set-category="setCategory"
          :collapse="collapse"
          :get-brands-list="getBrandsList"
          :load-more-brands="loadMoreBrands"
          :set-filter="setFilter"
        />
        <div class="right-content">
          <div class="top" ref="topRef">
            <h2>
              {{ filter.categoryName
              }}
              <CountryHostSelect
                v-model="filter.countryHost"
                :get-popup-container="() => $refs.topRef"
                @change="(option) => setFilter('country', option)"
              />
            </h2>
            <div class="top-filter">
              <div class="flex-left">
                <top-pagination :pagination="{
                  total: productCount,
                  size: filter.size,
                  current: filter.page,
                }" @pageChange="(page) => setFilter('page', page)" />
                <a-input-search allowClear class="search" placeholder="search..." v-model:value="filter.keywords"
                  @search="(v) => setFilter('keywords', v)" />
              </div>
              <div class="flex-right" ref="mainRef">
                <div class="flex-right-item">
                  <!-- 选择商品 -->
                  <template v-if="!canSelct">
                    <artmisads-select-button @click="selectProduct" class="select-product-button" size="middle">
                      Select
                    </artmisads-select-button>
                  </template>
                  <div v-else class="select-button-group">
                    <artmisads-select-button class="select-exit" @click="selectClear">
                      Exit
                    </artmisads-select-button>
                    <artmisads-select-button @click="selectCurrentPage" class="select-current-page-button">{{
                      selectCurrentPageStatus
                        ? 'Deselect Page'
                        : 'Select Page'
                    }}</artmisads-select-button>
                    <a-dropdown :getPopupContainer="() => mainRef">
                      <template #overlay>
                        <artmisads-dropdown-menu @click="handleExportClick" v-if="map.size">
                          <a-menu-item key="exportProductsInfo">
                            <svg size="20" class="icon artmisads-select-down-icon" aria-hidden="true"
                              style="margin-right: 4px">
                              <use xlink:href="#icon-daochu"></use>
                            </svg>
                            Export Products Info
                          </a-menu-item>
                        </artmisads-dropdown-menu>
                      </template>
                      <artmisads-button-special :class="[
                        map.size ? 'actions-button-active' : '',
                        'actions-button',
                      ]">
                        <span class="btn-text">Actions{{ map.size ? `(${map.size})` : '' }}</span>
                        <svg style="margin-left: 8px" class="icon artmisads-select-down-icon" aria-hidden="true">
                          <use xlink:href="#icon-jiantou-xia-cu"></use>
                        </svg>
                      </artmisads-button-special>
                    </a-dropdown>
                    <!-- <artmisads-select-button @click="">Actions({{map.size}})</artmisads-select-button> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="mid-filter-wrapper"> -->
            <div class="mid-filter" :class="{ expanded: isFilterExpanded }" ref="midFilterRef">
              <div class="mid-filter-item">
                <div class="mid-filter-title">Deals</div>
                <div class="mid-filter-checkbox">
                  <a-checkbox v-model:checked="filter.activeDeals" @change="setFilter">Active</a-checkbox>
                  <a-checkbox v-model:checked="filter.upcomingDeals" @change="setFilter"
                    class="upcoming-box">Upcoming</a-checkbox>
                </div>
              </div>
              <!-- <div class="mid-filter-item">
                <div class="mid-filter-title">Amazon Associate</div>
                <div class="mid-filter-checkbox">
                  <a-checkbox v-model:checked="filter.partnered" @change="setFilter">Partnered</a-checkbox>
                  <a-checkbox v-model:checked="filter.notPartnered" @change="setFilter" class="upcoming-box">Not
                    Partnered</a-checkbox>
                </div>
              </div> -->
              <div class="mid-filter-item">
                <div class="mid-filter-title">Availability</div>
                <div class="mid-filter-checkbox">
                  <a-checkbox v-model:checked="filter.inStockOnly" @change="setFilter">In Stock</a-checkbox>
                </div>
              </div>
              <div class="mid-filter-item">
                <div class="mid-filter-title">Products Variations</div>
                <div class="mid-filter-checkbox">
                  <a-checkbox v-model:checked="filter.hideVariationProducts" @change="setFilter">Hide</a-checkbox>
                </div>
              </div>
              <div class="mid-filter-item">
                <div class="mid-filter-title">Commission Min</div>
                <div class="commission-input">
                  <artmisads-input-number min="0" max="100" suffix="%" :step="0.1" class="width100-min"
                    v-model:value="commissionRef" placeholder="Please enter..."
                    @blur="(e) => setFilter('commission', e.target.value)"
                    @pressEnter="(e) => setFilter('commission', e.target.value)" />
                </div>
              </div>
              <div class="mid-filter-item" ref="priceRef">
                <div class="mid-filter-title">Price</div>
                <artmisads-select class="width100" :options="priceOptions" v-model:value="filter.price"
                  @select="(id, option) => setFilter('price', option)" :getPopupContainer="() => $refs.priceRef" />
              </div>
              <div class="mid-filter-item" ref="sortRef">
                <div class="mid-filter-title">Sort</div>
                <artmisads-select class="width100" v-model:value="filter.sort" :getPopupContainer="() => $refs.sortRef"
                  @change="(option) => setFilter('sort', option)">
                  <a-select-option value="-bestSellers" style="width: 160px">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-paixu1"></use>
                    </svg>
                    <span style="margin-left: 4px"> Best Sellers </span>
                  </a-select-option>
                  <a-select-option value="%2BbestSellers">
                    <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                      <use xlink:href="#icon-paixu1"></use>
                    </svg>
                    <span style="margin-left: 4px"> Best Sellers </span>
                  </a-select-option>
                  <a-select-option value="-newlyAdded">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-paixu1"></use>
                    </svg>
                    <span style="margin-left: 4px"> Newly Added </span>
                  </a-select-option>
                  <a-select-option value="-commission">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-paixu1"></use>
                    </svg>
                    <span style="margin-left: 4px"> Commission </span>
                  </a-select-option>
                  <a-select-option value="-price">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-paixu1"></use>
                    </svg>
                    <span style="margin-left: 4px"> Price </span>
                  </a-select-option>
                  <a-select-option value="%2Bprice">
                    <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                      <use xlink:href="#icon-paixu1"></use>
                    </svg>
                    <span style="margin-left: 4px"> Price </span>
                  </a-select-option>
                  <a-select-option value="-payout">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-paixu1"></use>
                    </svg>
                    <span style="margin-left: 4px"> Payout </span>
                  </a-select-option>
                  
                </artmisads-select>
              </div>
              <div class="mid-filter-item">
                <div class="mid-filter-title">Sensitive Categories</div>
                <div class="mid-filter-checkbox">
                  <a-checkbox v-model:checked="filter.hideSensitiveProducts" @change="setFilter">Hide</a-checkbox>
                </div>
              </div>
              <div class="expand-filter" v-if="shouldShowExpandButton" @click="expandFilter">
                <span :class="{ expandedText: isFilterExpanded }">{{
                  isFilterExpanded ? 'Collapse' : 'Expand'
                }}</span>
                <svg class="icon" aria-hidden="true" :class="{ expanded: isFilterExpanded }">
                  <use xlink:href="#icon-jiantou-you-shuang-cu"></use>
                </svg>
              </div>
            </div>

            <!-- </div> -->

            <!-- 暂时不显示 -->
            <div class="filter-list" v-if="false">
              <a-tag :closable="true" :key="brand.brandName" @close="setFilter('brand', { ...brand, remove: true })"
                v-for="brand in filter.selectedBrands">{{ brand.brandName }}</a-tag>
              <a-tag :closable="true" v-if="filter.commission" @close="setFilter('commission', null)">Commission Min {{
                filter.commission }}%</a-tag>
              <a-tag :closable="true" v-if="filter.inStockOnly" @close="setFilter('inStockOnly', false)">In
                Stock</a-tag>
              <a-tag :closable="true" @close="setFilter('price', { label: 'All' })"
                v-if="filter.minPrice || filter.maxPrice">{{
                  filter.price }}</a-tag>
              <a-tag class="reset-filter" v-if="filterCount" @click="resetFilter">Reset <em>{{ filterCount }}</em>
                Filters</a-tag>
            </div>
          </div>
          <a-divider style="border-color: #ccc7d9" dashed class="select-divider" v-if="canSelct">Selecting
            Products</a-divider>

          <div :class="'list' + (productCount <= filter.size ? ' single-page' : '')
            ">
            <div :class="[
              'item',
              canSelct
                ? product.selected
                  ? 'select-product'
                  : ''
                : 'item-hover',
            ]" @click="clickProduct(product)" v-for="(product, index) in productList" :key="product.id">
              <div class="img-wrapper">
                <div class="img-bg">
                  <div class="select-icon" v-if="canSelct">
                    <a-checkbox v-model:checked="product.selected"></a-checkbox>
                  </div>
                  <div v-if="product.combineDeal" class="deal-sign">Deal</div>
                  <img class="logo" :src="product.imageUrl" />
                  <p class="upcoming" v-if="product.markedUpcomingDeal">
                    Deal<br />{{
                      moment(product.markedUpcomingDeal?.beginTime).format(
                        'MM/DD',
                      )
                    }}
                    -
                    {{
                      moment(product.markedUpcomingDeal?.endTime).format(
                        'MM/DD',
                      )
                    }}
                  </p>
                </div>
                <span class="get-link" @click.stop="getTrackLink($event, index, product)">Get Link</span>
              </div>
              <p class="price">
                <span v-if="product.combineDeal">
                  <span>{{ product.combineDeal?.currencySymbol
                  }}{{ product.combineDeal?.finalPrice?.toFixed(2) }}</span>
                  <span class="original">{{ product.combineDeal.currencySymbol
                  }}{{ product.combineDeal?.fullPrice?.toFixed(2) }}
                  </span>
                </span>
                <span v-else>
                  {{ product.currencySymbol }}{{ product.price }}
                </span>
              </p>
              <p class="priceOff" v-if="product.combineDeal">
                {{ product.combineDeal?.priceOff?.toFixed(1) }}% off
              </p>
              <p class="title">
                {{ product.title }}
              </p>
              <div class="star">
                <a-rate :value="+product.productStarRating" allow-half disabled />{{ product.productNumRatings }}
              </div>
              <a-popover overlayClassName="test" :overlayInnerStyle="{ padding: '8px' }" placement="left"
                :mouseEnterDelay="0.5">
                <template #content>
                  <div class="popover-content">
                    <div class="popover-content-item">
                      <div class="popover-item-top">
                        <img src="../../../assets/images/img/attr.png" alt="" class="popover-img">
                        <div class="popover-item-top-right">
                          <Icon name="Frame" class="icon-frame" v-if="product?.associateCommissionChangeOperations"/>
                          <template v-if="product?.associateCommissionChangeOperations">
                            <span class="popover-title">Until {{
                              moment(product?.associateCommissionChangeOperations[0]?.displayTime)
                                .tz(timezone)
                                .format('MM/DD') }}</span>
                          </template>
                          <template v-else>
                            <!-- <span class="popover-title">--</span> -->
                          </template>
                        </div>
                      </div>
                      <div class="popover-item-content">
                        <div class="popover-item-content-item" style="padding-top: 5px;">
                          <span class="popover-item-content-item-title">
                            Commission:
                          </span>
                          <span class="popover-item-content-item-text color">
                            {{ product.commission && product.status == 'active' ? product.commission : '--' }}%
                          </span>
                        </div>
                        <div class="popover-item-content-item" style="padding-bottom: 8px;">
                          <span class="popover-item-content-item-title">
                            Est. Payout:
                          </span>
                          <span class="popover-item-content-item-text" style="color: rgba(230, 130, 0, 1);">
                            {{ product.commission && product.status == 'active' ? product.currencySymbol +
                              Number(product.estPayout)?.toFixed(2)
                              : '--' }}
                            <!-- {{ product.currencySymbol
                            }}{{ Number(product.estPayout)?.toFixed(2) }} -->
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="popover-content-item">
                      <div class="popover-item-top">
                        <img src="../../../assets/images/img/ass.png" alt="" class="popover-img">
                        <div class="popover-item-top-right">
                          <Icon name="Frame" class="icon-frame" v-if="product?.commissionChangeOperations"/>
                          <span class="popover-title">
                            <template v-if="product?.commissionChangeOperations">
                              <span class="popover-title">Until {{
                                moment(product?.commissionChangeOperations[0]?.displayTime)
                                  .tz(timezone)
                                  .format('MM/DD') }}</span>
                            </template>
                            <template v-else>
                            
                            </template>
                          </span>
                        </div>
                      </div>
                      <div class="popover-item-content">
                        <div class='popover-item-content-top-two' v-if="product.accCommission">
                          <div class='popover-item-content-top-two-title'>
                            Associate({{ product.originalAssociateCommission }}%)
                            <img class="equal" :src="require('@/assets/images/img/equal.png')"
                              alt="Commission rate adjustment policy"
                              v-if="product.originalAssociateCommission <= product.accCommission" />
                            <img class="equal" :src="require('@/assets/images/img/greater.png')" v-else
                              alt="Commission rate adjustment policy" />
                            Creator Connections ({{ product.accCommission }}%)
                          </div>
                          <div class="popover-item-content-top-two-content"
                            v-if="product.originalAssociateCommission <= product.accCommission">
                            all payments are settled directly by Amazon
                          </div>
                          <div class="popover-item-content-top-two-content" v-else>
                            Commission difference will be paid via ArtemisAds
                          </div>
                        </div>
                        <div class="popover-item-content">
                          <div class="popover-item-content-item" style="padding-top: 5px;">
                            <span class="popover-item-content-item-title">
                              Commission:
                            </span>
                       
                            <span class="popover-item-content-item-text" v-if="product.accCommission">
                              {{ product.originalAssociateCommission }}%-{{ product.accCommission }}% = <span
                                class="commission-rate">
                                {{ Math.max(0, product.originalAssociateCommission - product.accCommission) }}%
                              </span>
                            </span>
                            <span v-else class="popover-item-content-item-text color">
                              {{ product.associateCommission ? product.associateCommission : '--' }}%
                            </span>
                          </div>
                          <div class="popover-item-content-item" style="padding-bottom: 8px;">
                            <span class="popover-item-content-item-title">
                              Est. Payout:
                            </span>
                            <span class="popover-item-content-item-text" style="color: rgba(230, 130, 0, 1);">
                              {{ product.currencySymbol
                              }}{{
                                Number(product.associateEstPayout)?.toFixed(2)
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                     
                    </div> -->
                    <div class="popover-content-item">
                      <div class="popover-item-top">
                        <img src="../../../assets/images/img/cc.png" alt="" class="popover-img">
                      </div>
                      <div class="popover-item-content" v-if="product.accCommission">
                        <div class="popover-item-content-item" style="padding-top: 5px;">
                          <span class="popover-item-content-item-title">
                            Amazon Commission:
                          </span>
                          <span class="popover-item-content-item-text color">
                            {{ product.accCommission ? product.accCommission : '--' }}%
                          </span>
                        </div>
                        <div class="popover-item-content-item" style="padding-bottom: 8px;">
                          <span class="popover-item-content-item-title">
                            all payments are settled directly by <span class="amazon">Amazon</span>
                          </span>

                        </div>
                      </div>
                      <div v-else class="popover-item-content-item-title-not">
                        The brand has not authorized ACC, or you have not accept the ACC Campaign for this product.
                      </div>
                    </div>
                  </div>


                  <!-- <div class="popover-content" style="padding: 0px">
                    <div class="popover-item">
                      <div class="popover-item-top">
                        <img
                          src="../../../assets/images/img/AT.png"
                          alt=""
                          class="popover-img"
                        />
                        <span class="popover-title">Attribution Rate</span>
                      </div>
                      <div class="popover-item-bottom" style="margin: 6px 0">
                        <div class="popover-item-bottom-title">Commission:</div>
                        <div
                          class="popover-item-bottom-text"
                          v-if="
                            product.commission && product.status == 'active'
                          "
                        >
                          {{
                            product.commission ? product.commission + '%' : '--'
                          }}
                        </div>
                        <div class="popover-item-bottom-no" v-else>--</div>
                      </div>
                      <div class="popover-item-bottom">
                        <div class="popover-item-bottom-title">
                          Est. Payout:
                        </div>
                        <div
                          class="popover-item-bottom-currency"
                          v-if="product.estPayout"
                        >
                          {{
                            product.estPayout
                              ? product.currencySymbol +
                                Number(product.estPayout)?.toFixed(2)
                              : '--'
                          }}
                        </div>
                        <div class="popover-item-bottom-no" v-else>--</div>
                      </div>
                    </div>
                    <div class="popover-item" style="margin-top: 16px">
                      <div class="popover-item-top">
                        <img
                          src="../../../assets/images/img/AS.png"
                          alt=""
                          class="popover-img"
                        />
                        <span class="popover-title">Associate Rate</span>
                      </div>
                      <div class="popover-item-bottom" style="margin: 6px 0">
                        <div class="popover-item-bottom-title">Commission:</div>
                        <div
                          class="popover-item-bottom-text"
                          v-if="
                            product.associateCommission &&
                            product.associateStatus == 'active'
                          "
                        >
                          {{
                            product.associateCommission
                              ? product.associateCommission + '%'
                              : '--'
                          }}
                        </div>
                        <div class="popover-item-bottom-no" v-else>--</div>
                      </div>
                      <div class="popover-item-bottom">
                        <div class="popover-item-bottom-title">
                          Est. Payout:
                        </div>
                        <div
                          class="popover-item-bottom-currency"
                          v-if="product.associateEstPayout"
                        >
                          {{
                            product.associateEstPayout
                              ? product.currencySymbol +
                                Number(product.associateEstPayout)?.toFixed(2)
                              : '--'
                          }}
                        </div>
                        <div class="popover-item-bottom-no" v-else>--</div>
                      </div>
                    </div>
                  </div> -->
                </template>
                <div class="place-bottom">
                  <div class="place-bottom-item">
                    <img src="../../../assets/images/img/attr.png" alt="" class="place-bottom-img" />
                    <!-- <span class="item-title">Comm:</span> -->
                    <template v-if="(product.commission || product.commission == 0) && product.status == 'active'">
                      <span class="item-text">{{ product.commission }}%</span>
                      <span class="symbol">/</span>
                      <span class="item-currency">{{ product.currencySymbol
                      }}{{ Number(product.estPayout)?.toFixed(2) }}</span>
                    </template>
                    <template v-else>
                      <span class="symbol">--</span>
                    </template>
                  </div>
                  <!-- <div class="place-bottom-item">
                    <img src="../../../assets/images/img/ass.png" alt="" class="place-bottom-img" />

                    <template v-if="
                      (product.associateCommission || product.associateCommission == 0) &&
                      product.associateStatus == 'active'
                    ">
                      <span class="item-text">{{ product.associateCommission }}%</span>
                      <template v-if="!product.originalAssociateCommission">
                        <span class="symbol">/</span>
                        <span class="item-currency">{{ product.currencySymbol
                        }}{{
                            Number(product.associateEstPayout)?.toFixed(2)
                          }}</span>
                      </template>
                      <template v-else>
                        <div class="originalAssociateCommission">
                          {{ product.originalAssociateCommission }}%
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <span class="symbol">--</span>
                    </template>
                    <div>
                         <Icon name="wenhao-tianchong" class="icon-info-tianchong-mid" />
                    </div>
                  </div> -->
                  <div class="place-bottom-item">
                    <img src="../../../assets/images/img/accItem.png" alt="" class="place-bottom-img" />
                    <!-- <span class="item-title">Comm:</span> -->
                    <template v-if="
                      product.accCommission ||
                      product.accCommission == 0
                      //&& product.associateStatus == 'active'
                    ">
                      <span class="item-accCommission">{{ product.accCommission }}%</span>

                    </template>
                    <template v-else>
                      <span class="symbol">--</span>
                    </template>
                  </div>
                </div>
              </a-popover>
            </div>
          </div>
          <a-pagination class="pagination" show-less-items @change="setPage" :total="productCount"
            :pageSize="filter.size" :showSizeChanger="true" v-model:current="filter.page"
            v-if="productCount > filter.size" :pageSizeOptions="['10', '20', '30', '50', '100']"
            @showSizeChange="(c, size) => setFilter('size', size)">
            <template #buildOptionText="props">
              <span>{{ props.value }} per page</span>
            </template>
            <template #itemRender="{ type, originalElement }">
              <a v-if="type === 'prev'">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-jiantou-zuo-cu"></use>
                </svg>
              </a>
              <a v-else-if="type === 'next'">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-jiantou-you-cu"></use>
                </svg>
              </a>
              <component :is="originalElement" v-else></component>
            </template>
          </a-pagination>
          <no-data v-if="productCount == 0" />
        </div>

        <!-- 两种场景 -->
        <!-- 从未生成过Track Link的需要传productId -->
        <!-- 生成过Track Link的则需要传trackLinkId -->
        <LinkToolModal :productId="linkModalParams.productId" linkType="product"
          :associateStatus="linkModalParams.associateStatus" :attributionStatus="linkModalParams.status"
          :trackLinkId="linkModalParams.openTrackLinkId" :countryCode="linkModalParams.countryCode"
          v-model:open="linkModalParams.open" @callback="onSaveCallback" />
      </div>
    </a-spin>
  </div>
</template>

<script setup>
import moment from 'moment'
import { reactive, ref, watch, onMounted, onUnmounted, nextTick } from 'vue'
import debounce from 'lodash/debounce'
import NoData from '~/components/NoData.vue'
import Icon from '@/components/Icon.vue'
import CountryHostSelect from '@/components/CountryHostSelect.vue'
import { PRICE } from '../../../contants/publisher'
import { publisherApi, publisherProductApi } from '../../../server/index'
import breadcrumbs from '../../seller/breadcrumbs.vue'
import TopPagination from '~/components/TopPagination.vue'
import { CURRENCY_MAPPER } from '../../../contants/common'
import LinkToolModal from './detail/linkToolModal.vue'
import LeftFilterPanel from '@/pages/publisher/products/components/LeftFilterPanel.vue'
import { message } from 'ant-design-vue'
import { useRoute } from 'vue-router'
import { useUserInfoStore } from '~/storeData/index'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'

const route = useRoute()
const store = useUserInfoStore()
const hasQuery = ref(false)
const isPopoverOpen = ref(true)
const breadcrumbsData = {
  color: '#4682FA',
  hasTitleIcon: true,
  title: 'Products Catalogue',
  des: 'Find the products you want to promote!',
  links: [
    {
      name: 'Home',
      path: '/publisher/products',
    },
    {
      name: 'Products',
      path: '/publisher/products',
    },
  ],
}
const commissionRef = ref(null)
let [countryCode, categoryId, categoryLevel] = (
  localStorage.getItem('previewCategory') || ''
).split('_')

if (!countryCode && localStorage.getItem('selectedSite')) {
  countryCode = localStorage.getItem('selectedSite')
}
const map = reactive(new Map())
const filter = ref({
  page: 1,
  size: 20,
  partnered: false,
  notPartnered: false,
  hideSensitiveProducts: false,
  hideVariationProducts: true,
  price: 'All',
  deal: 'Off',
  keywords: '',
  currency: '$',
  minPrice: null,
  maxPrice: null,
  keywords: null,
  commission: null,
  activeDeals: false,
  upcomingDeals: false,
  countryCode: countryCode || 'US',
  inStockOnly: false,
  selectedBrands: [],
  categoryName: 'All',
  sort: '-bestSellers',
  countryHost: CURRENCY_MAPPER[countryCode || 'US'].host,
  categoryLevel: categoryLevel || null,
  categoryId: categoryId || null,
})
const timezone = COUNTRY_TIME_TZ[filter.value.countryCode]

const filterCount = ref(0)
const productCount = ref(0)
const brands = ref([])
const productList = ref([])
const leftFilterPanelRef = ref(null)
const isLoadingList = ref(false)
const brandCollapsed = ref(false)
const isLoadingBrands = ref(false)
const isSearchingBrands = ref(false)
const categoryCollapsed = ref(false)
const priceOptions = ref(null)
const brandSearch = ref({
  page: 1,
  size: 10,
  total: 0,
  brandName: '',
  inStockOnly: false,
})
const linkModalParams = ref({
  open: false,
  productId: null,
  trackLinkId: null,
  productIndex: null,
  countryCode: filter.value.countryCode,
  associateStatus: 'active',
  status: 'active',
})
const canSelct = ref(false)
const mainRef = ref(null)
const selectCurrentPageStatus = ref(false)
const shouldShowExpandButton = ref(false)
const midFilterRef = ref(null)
const isFilterExpanded = ref(false)

// 检测筛选器是否换行并隐藏第二行元素
function checkIfWrapped () {
  nextTick(() => {
    const midFilterElement = midFilterRef.value
    if (!midFilterElement) return

    const filterItems = midFilterElement.querySelectorAll('.mid-filter-item')
    if (filterItems.length <= 1) {
      shouldShowExpandButton.value = false
      return
    }

    // 如果当前是展开状态，显示所有元素
    if (isFilterExpanded.value) {
      shouldShowExpandButton.value = true
      // 移除所有隐藏类
      filterItems.forEach((item) => {
        item.classList.remove('filter-item-hidden')
      })
      return
    }

    // 先移除所有隐藏类来检测真实位置
    filterItems.forEach((item) => {
      item.classList.remove('filter-item-hidden')
    })

    // 强制重新计算布局
    midFilterElement.offsetHeight

    // 检测第一行元素的offsetTop
    const firstItemTop = filterItems[0].offsetTop
    let hasSecondRow = false

    // 检查每个元素是否在第二行，如果是则隐藏
    filterItems.forEach((item, index) => {
      if (item.offsetTop > firstItemTop) {
        // 这个元素在第二行，隐藏它
        item.classList.add('filter-item-hidden')
        hasSecondRow = true
      }
    })

    // 如果有第二行元素，显示展开按钮
    shouldShowExpandButton.value = hasSecondRow
  })
}

// 防抖的检测函数
const debouncedCheckIfWrapped = debounce(checkIfWrapped, 100)

function getBrandsList (event) {
  const keywords = event ? event.target.value : undefined

  if (keywords != undefined) {
    brandSearch.value.page = 1
    isSearchingBrands.value = true
    brandSearch.value.brandName = keywords
  } else {
    isLoadingBrands.value = true
  }
  let params = {
    ...brandSearch.value,
    countryCode: filter.value.countryCode,
  }
  if (params.brandName) {
    params.brandName = encodeURIComponent(params.brandName)
  }

  publisherApi
    .getBrandsList(params)
    .then((res) => {
      const result = res.data.map((item) => {
        return {
          ...item,
          selected: hasQuery.value ? true : false,
        }
      })

      if (keywords != undefined) {
        isSearchingBrands.value = false
      } else {
        isLoadingBrands.value = false
      }

      if (brandSearch.value.page === 1) {
        brandSearch.value.total = res.total

        if (keywords != undefined) {
          const filterSelectedBrands = filter.value.selectedBrands.filter(
            (brand) =>
              brand.brandName.toLowerCase().indexOf(keywords.toLowerCase()) !=
              -1,
          )

          brands.value = [
            ...filterSelectedBrands,
            ...result.filter((item) => {
              for (const s of filterSelectedBrands) {
                if (s.brandName === item.brandName) {
                  return false
                }
              }

              return true
            }),
          ]
        } else {
          brands.value = result
        }
      } else {
        brands.value = [...brands.value, ...result]
      }
      hasQuery.value = false
    })
}

function getProductList () {
  const params = { ...filter.value }
  if (filter.value.keywords) {
    params.keywords = encodeURIComponent(filter.value.keywords)
  }

  if (filter.value.activeDeals) {
    params.deal = filter.value.upcomingDeals ? 'All' : 'Active'
  } else {
    params.deal = filter.value.upcomingDeals ? 'Upcoming' : 'Off'
  }
  if (filter.value.hideVariationProducts) {
    params.hideVariationProducts = true
  } else {
    params.hideVariationProducts = false
  }
  if (filter.value.partnered && filter.value.notPartnered) {
    params.associatePartneredFilter = 'all'
  } else {
    if (filter.value.partnered) {
      params.associatePartneredFilter = 'partnered'
    } else if (filter.value.notPartnered) {
      params.associatePartneredFilter = 'not_partnered'
    } else {
      params.associatePartneredFilter = ''
    }
  }
  Object.keys(params).forEach((key) => {
    if (
      [
        'price',
        'categoryName',
        'countryHost',
        'activeDeals',
        'upcomingDeals',
        'partnered',
        'notPartnered',
      ].indexOf(key) != -1 ||
      ['', null, undefined].indexOf(params[key]) != -1
    ) {
      delete params[key]
    }
  })

  if (params.selectedBrands.length) {
    params.brandNames = encodeURIComponent(params.selectedBrands.map((item) => item.brandName))
  }
  if (hasQuery.value) {
    params.brandNames = [brandSearch.value.brandName]
  }
  delete params['selectedBrands']

  isLoadingList.value = true
  publisherApi.getProductList(params).then((res) => {
    isLoadingList.value = false
    if (filter.value.page == 1) {
      productCount.value = res.total || 0
    }

    productList.value = res.data.map((item) => {
      return {
        ...item,
        selected: false,
      }
    })
    if (map.size > 0) {
      productList.value.forEach((item) => {
        if (map.has(item.id)) {
          item.selected = map.get(item.id)
        }
      })
      // 如果当前页所有商品都选中，则将当前页状态设置为选中
      if (
        productList.value.every((item) => {
          return item.selected === true
        })
      ) {
        selectCurrentPageStatus.value = true
      } else {
        selectCurrentPageStatus.value = false
      }
    }

    // 数据加载完成后重新检测布局，保持当前展开状态
    nextTick(() => {
      checkIfWrapped()
    })
  })
}

const getPublisherProductSearchParamsHistory = async (countryCodeInfo) => {
  const res = await publisherProductApi.getSearchParamsHistory({
    countryCode: countryCodeInfo,
  })
  if (res.success) {
    sessionStorage.setItem('searchParams', JSON.stringify(res.data))
  }
}
onMounted(async () => {
  const { brandName, countryCode, partnered, hideVariationProducts } =
    route.query

  await getPublisherProductSearchParamsHistory(
    countryCode ? countryCode : store?.userInfo?.countryCode || 'US',
  )
  if (sessionStorage.getItem('searchParams')) {
    const searchParams = JSON.parse(sessionStorage.getItem('searchParams'))
    //  if(searchParams)
    filter.value = { ...filter.value, ...searchParams }
    if (searchParams?.associatePartneredFilter == 'all') {
      filter.value.partnered = true
      filter.value.notPartnered = true
    }
    if (searchParams?.associatePartneredFilter?.trim() == 'partnered') {
      filter.value.partnered = true
    }
    if (searchParams?.associatePartneredFilter?.trim() == 'not_partnered') {
      filter.value.notPartnered = true
    }
    if (searchParams?.sort) {
      filter.value.sort = searchParams.sort.replace(/\+/g, '%2B')
    }
    filter.value.hideVariationProducts = true
    if (searchParams?.deal === 'All' || searchParams?.deal === 'Active') {
      filter.value.activeDeals = true
      if (searchParams?.deal === 'All') {
        filter.value.upcomingDeals = true
      }
      if (searchParams?.deal === 'Active') {
        filter.value.upcomingDeals = false
      }
    } else {
      if (searchParams?.deal === 'Upcoming') {
        filter.value.activeDeals = false
        filter.value.upcomingDeals = true
      }
      if (searchParams?.deal === 'Off') {
        filter.value.activeDeals = false
        filter.value.upcomingDeals = false
      }
    }
    commissionRef.value = searchParams?.commission
    //  if(searchParams.brandNames.length){
    //    filter.value.selectedBrands = searchParams.brandNames.map((item) => ({ brandName: item, selected: true }))
    //  }
    if (searchParams?.maxPrice == '10') {
      filter.value.price = 'Under %s10'
    }
    if (searchParams?.minPrice == '10' && searchParams?.maxPrice == '25') {
      filter.value.price = '%s10 to %s25'
    }
    if (searchParams?.minPrice == '25' && searchParams?.maxPrice == '50') {
      filter.value.price = '%s25 to %s50'
    }
    if (searchParams?.minPrice == '50' && searchParams?.maxPrice == '100') {
      filter.value.price = '%s50 to %s100'
    }
    if (searchParams?.minPrice == '100' && searchParams?.maxPrice == '200') {
      filter.value.price = '%s100 to %s200'
    }
    if (searchParams?.minPrice == '200') {
      filter.value.price = '%s200 & Above'
    }
    if (searchParams?.minPrice == '200' && searchParams?.maxPrice == '500') {
      filter.value.price = '%s200 to %s500'
    }
  }
  if (brandName) {
    filter.value.selectedBrands = [{ brandName: brandName, selected: true }]
    brandSearch.value.brandName = brandName
    hasQuery.value = true
  }
  if (hideVariationProducts) {
    filter.value.hideVariationProducts = false
  }

  if (countryCode) {
    filter.value.countryCode = countryCode
    filter.value.countryHost = CURRENCY_MAPPER[countryCode].host
  }
  if (partnered) {
    filter.value.partnered = true
  }
  await getBrandsList()
  await setPriceCurrency()
  await getProductList()

  // 初始检测是否换行
  checkIfWrapped()

  // 监听窗口大小变化
  window.addEventListener('resize', debouncedCheckIfWrapped)
  // hasQuery.value=false
})

// 清理事件监听器
onUnmounted(() => {
  window.removeEventListener('resize', debouncedCheckIfWrapped)
})
function setPriceCurrency () {
  priceOptions.value = PRICE.map((item) => {
    return {
      ...item,
      label: item.label.replace(
        /%s/g,
        CURRENCY_MAPPER[filter.value.countryCode].currency,
      ),
      value: item.label,
      minPrice: item.min ? filter.value.currency + item.min : null,
      maxPrice: item.max ? filter.value.currency + item.max : null,
    }
  })
  filter.value.price = filter.value.price.replace(
    /[$|£|€]/g,
    filter.value.currency,
  )
}

function setFilter (type, option) {
  if (type == 'page') {
    filter.value.page = option
  } else {
    if (type == 'price') {
      // price
      filter.value.price = option.label
      filter.value.minPrice = option.min || null
      filter.value.maxPrice = option.max || null
      filter.value.page = 1
    } else if (type == 'sort') {
      filter.value.sort = option
      filter.value.page = 1
    } else if (type == 'size') {
      filter.value.size = option
      filter.value.page = 1
    } else if (type == 'country') {
      filter.value.selectedBrands = []
      brandSearch.value.brandName = ''
      filter.value.categoryId = null
      filter.value.categoryName = 'All'
      filter.value.categoryLevel = null
      filter.value.currency = option.currency
      filter.value.countryHost = option.value
      filter.value.countryCode = option.key.toUpperCase()
      linkModalParams.value.countryCode = filter.value.countryCode

      getBrandsList()
      setPriceCurrency()
      localStorage.setItem('selectedSite', filter.value.countryCode)
      leftFilterPanelRef.value?.getCategories({
        level: 1,
        categoryId: 0,
        countryChanged: true,
      })
    } else if (type == 'keywords') {
      if (option.type) {
        if (option.type == 'click') {
          // clear event
          filter.value.page = 1
        } else {
          return
        }
      } else {
        filter.value.keywords = option
      }
    } else if (type == 'commission') {
      if (filter.value.commission == option) {
        return
      }
      if (isNaN(parseFloat(option))) {
        filter.value.commission = undefined
        commissionRef.value = undefined
      } else {
        filter.value.commission = Math.floor(option * 10) / 10
      }
    } else if (type == 'inStockOnly') {
      filter.value.inStockOnly = option
    } else if (type == 'activeDeals') {
      filter.value.activeDeals = option
    } else if (type == 'upcomingDeals') {
      filter.value.upcomingDeals = option
    } else if (type == 'brand') {
      if (!option.remove) {
        // 取消品牌选中
        if (option.selected) {
          filter.value.selectedBrands = filter.value.selectedBrands.filter(
            (brand) => brand.brandName != option.brandName,
          )
          brands.value[option.index].selected = false
        } else {
          // 选中品牌
          filter.value.selectedBrands.push({ ...option, selected: true })
          brands.value[option.index].selected = true
        }
      } else {
        // topFilter取消品牌选中

        filter.value.selectedBrands = filter.value.selectedBrands.filter(
          (item) => item.brandName != option.brandName,
        )

        const index = brands.value.findIndex(
          (item) => item.brandName === option.brandName,
        )

        brands.value[index].selected = false
      }

    } else if (type == 'category') {
      filter.value = {
        ...filter.value,
        ...option,
      }
    }

    filter.value.page = 1
  }

  getProductList()
  // 筛选条件变化后检测是否换行，保持当前展开状态
  nextTick(() => {
    checkIfWrapped()
  })
}

function setCategory (category) {
  if (category.categoryId) {
    const { categoryId, displayName, level } = category

    filter.value.categoryLevel = level
    filter.value.categoryId = categoryId
    filter.value.categoryName = displayName
  } else {
    filter.value.categoryId = null
    filter.value.categoryLevel = null
    filter.value.categoryName = 'All'
    leftFilterPanelRef.value?.getCategories({ categoryId: 0, level: 1 })
  }

  filter.value.page = 1
  getProductList()
}

function setPage (page) {
  filter.value.page = page
  // selectCurrentPageStatus.value=false
  getProductList()
}

function resetFilter () {
  commissionRef.value = ''
  filter.value.price = 'All'
  filter.value.minPrice = null
  filter.value.maxPrice = null
  filter.value.commission = null
  filter.value.inStockOnly = false
  filter.value.selectedBrands = []
  brands.value = brands.value.map((item) => {
    return {
      ...item,
      selected: false,
    }
  })
  getProductList()
}

function collapse (type) {
  if (type === 'category') {
    categoryCollapsed.value = !categoryCollapsed.value
  } else {
    brandCollapsed.value = !brandCollapsed.value
  }
}

const loadMoreBrands = debounce((e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target
  if (clientHeight + scrollTop >= scrollHeight - 50) {
    if (
      brandSearch.value.total >
      brandSearch.value.page * brandSearch.value.size
    ) {
      brandSearch.value.page += 1
      getBrandsList()
    }
  }
}, 300)

function getTrackLink (event, index, product) {
  event.preventDefault() // 阻止 <a> 标签的默认跳转行为
  event.stopPropagation() // 确保事件不会冒泡
  linkModalParams.value.open = true
  linkModalParams.value.productIndex = index
  linkModalParams.value.productId = product.id
  linkModalParams.value.associateStatus = product.associateStatus
  linkModalParams.value.status = product.status
}
function onSaveCallback () {
  linkModalParams.value.open = false
}

watch(filter.value, (val) => {
  filterCount.value = val.selectedBrands.length
  filterCount.value += val.commission ? 1 : 0
  filterCount.value += val.inStockOnly ? 1 : 0
  filterCount.value += val.minPrice || val.maxPrice ? 1 : 0
})
const selectProduct = () => {
  canSelct.value = !canSelct.value
}
const selectCurrentPage = () => {
  if (selectCurrentPageStatus.value) {
    productList.value.forEach((item) => {
      item.selected = false
      map.delete(item.id)
    })
  } else {
    productList.value.forEach((item) => {
      if (map.size < 200) {
        item.selected = true
        map.set(item.id, true)
      }
    })
    if (map.size >= 200) {
      message.error('You can only select 200 products at a time')
    }
  }
  selectCurrentPageStatus.value = !selectCurrentPageStatus.value
}
const selectClear = () => {
  canSelct.value = false
  selectCurrentPageStatus.value = false
  map.clear()
  productList.value = productList.value.map((item) => {
    return {
      ...item,
      selected: false,
    }
  })
}
const clickProduct = (product) => {

  if (!canSelct.value) {
    window.open(`/publisher/products/${product.id}`)
  } else {
    product.selected = !product.selected
    if (map.has(product.id)) {
      map.delete(product.id)
    } else {
      if (map.size < 200) {
        map.set(product.id, product.selected)
      } else {
        message.error('You can only select 200 products at a time')
      }
    }
  }
}
const handleExportClick = async ({ key }) => {
  // console.log(key)
  switch (key) {
    case 'exportProductsInfo':
      // console.log([...map.keys()])
      let productIds = [...map.keys()]
      const name = `Product_Export_${moment().format('YYYY-MM-DD')}`
      await publisherApi.exportProduct(name, { productIds: productIds })
      break
  }
}

// Expand按钮点击事件处理
const expandFilter = () => {
  isFilterExpanded.value = !isFilterExpanded.value

  // 状态切换后重新检测和调整元素显示
  nextTick(() => {
    checkIfWrapped()
  })
}
</script>

<style lang="less" scoped>
@import '../../../assets/less/ellipsis.less';
@import '../../../assets/less/pagination.less';
@import '../../../assets/less/ant-checkbox.less';
@import '../../../assets/less/country-select.less';
.icon-frame{
  color: rgba(15, 6, 41, 0.7);
  font-size: 14px;
}
.color {
  color: rgba(121, 79, 242, 1) !important;
}
.icon-info-tianchong-mid{
   color: rgba(15, 6, 41, 0.3);
    margin-left: 8px;
    font-size: 14px;
}
.popover-item-content-item-title-not {
  // padding-left: 16px;
  padding: 8px 16px;
  font-family: Sora;
  font-weight: 400;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.5);
}

.item-accCommission {
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgba(15, 6, 41, 0.5);
}

.originalAssociateCommission {
  font-family: Sora;
  font-weight: 500;
  font-size: 11px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  text-decoration: line-through;
  color: rgba(15, 6, 41, 0.5);
  padding-left: 5px;
}

.item-accCommissio {
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgba(15, 6, 41, 0.5);
}

.popover-content {
  border-radius: var(--Radius-Radius-6, 6px);
  background: #fff;
  padding: 8px;
  width: 357px;

  .popover-content-item:not(:first-child) {
    margin-top: 16px;
  }

  .popover-content-item {

    background-color: rgba(249, 249, 251, 1);
    border-radius: var(--Radius-Radius-6, 6px);

    .popover-img {
      // width: 64px;
      height: 16px;
    }

    .popover-item-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(232, 229, 237, 1);
      padding: 8px 16px;

      .popover-item-top-right {
        display: flex;
        align-items: center;
        gap: 7px;

        .popover-title {
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 11px;
          leading-trim: NONE;
          line-height: 20px;
          letter-spacing: 0.4px;
          color: rgba(15, 6, 41, 0.7);
        }
      }
    }

    .popover-item-content {
      .equal {
        width: 7px;
      }

      // margin-top: 5px;
      // margin: 5px 16px 0;

      .popover-item-content-item {
        padding-left: 20px;

        .popover-item-content-item-title {
          font-family: Sora;
          font-weight: 400;
          font-size: 12px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 0.5);

          .amazon {
            color: rgba(15, 6, 41, 0.7);
            font-family: Sora;
            font-weight: 700;
            font-size: 11px;
            leading-trim: NONE;
            line-height: 18px;
            letter-spacing: 0.3px;

          }
        }

        .popover-item-content-item-text {
          font-family: Sora;
          font-weight: 500;
          font-size: 12px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 0.9);

          .commission-rate {
            color: rgba(121, 79, 242, 1);
          }
        }
      }

      .popover-item-content-top-two {
        padding: 8px 10px;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 4px;
        margin: 5px 16px;

        .popover-item-content-top-two-title {
          font-family: Sora;
          font-weight: 500;
          font-style: Medium;
          font-size: 11px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 1);
        }

        .popover-item-content-top-two-content {
          font-family: Sora;
          font-weight: 400;
          font-size: 11px;
          leading-trim: NONE;
          line-height: 18px;
          letter-spacing: 0.3px;
          color: rgba(15, 6, 41, 0.5);
          padding-top: 6px;
        }

      }
    }
  }

  // .popover-img {
  //   width: 27px;
  //   height: 16px;
  // }
  // .popover-item {
  //   border-radius: var(--Radius-Radius-6, 6px);
  //   background: #f9f9fb;
  //   padding: 0px;

  //   .popover-item-top {
  //     display: flex;
  //     align-items: center;
  //     gap: 8px;
  //     border-bottom: 1px solid #e8e5ed;
  //     padding: 8px;
  //     .popover-title {
  //       color: #0f0629e6;
  //       font-family: 'Sora';
  //       font-size: 12px;
  //       font-style: normal;
  //       font-weight: 400;
  //       letter-spacing: 0.3px;
  //     }
  //   }
  //   .popover-item-bottom-no {
  //     color: #0f06294d;
  //     font-family: 'Sora';
  //     font-size: 12px;
  //     font-style: normal;
  //     font-weight: 400;
  //     letter-spacing: 0.3px;
  //   }
  //   .popover-item-bottom {
  //     display: flex;
  //     gap: 5px;
  //     padding: 0 25px;
  //     .popover-item-bottom-title {
  //       color: #0f0629;
  //       font-family: 'Sora';
  //       font-size: 12px;
  //       font-style: normal;
  //       font-weight: 400;
  //       letter-spacing: 0.3px;
  //       opacity: 0.5;
  //     }
  //     .popover-item-bottom-text {
  //       color: #794ff2;
  //       font-family: 'Sora';
  //       font-size: 12px;
  //       font-style: normal;
  //       font-weight: 500;

  //       letter-spacing: 0.3px;
  //     }
  //     .popover-item-bottom-currency {
  //       color: #e68200;
  //       font-family: 'Sora';
  //       font-size: 12px;
  //       font-style: normal;
  //       font-weight: 500;
  //       letter-spacing: 0.3px;
  //     }
  //   }
  // }
}

.expand-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 54px;
  transform: translateY(-50%);

  z-index: 10;

  .expandedText {
    color: #6c3df2;
  }

  span {
    font-size: 13px;
    color: #0f0629;
    font-weight: 500;
  }

  .icon {
    width: 16px;
    height: 16px;

    transform: rotate(90deg);
    color: #0f0629;
    margin-left: 4px;
    transition: transform 0.3s ease;

    &.expanded {
      transform: rotate(270deg);
      color: #6c3df2;
    }
  }

  &:hover {
    span {
      color: var(--primary);
    }

    .icon {
      color: var(--primary);
    }
  }
}

.width100 {
  max-width: 180px !important;
  min-width: 146px !important;
}

.width100-min {
  min-width: 100px !important;
  max-width: 180px !important;
}

.upcoming-box {
  margin-left: 8px;
}

.icon-select {
  fill: var(--primary);
  width: 32px;
  height: 32px;
  position: relative;
  z-index: 100;
  // background-color: #fff;
}

.select-icon {
  width: 16px;
  height: 16px;
  position: absolute;
  top: -3px;
  left: 0px;
  z-index: 100;
}

.select-icon-bg {
  width: 20px;
  height: 20px;
  position: absolute;
  background-color: #fff;
  border: 0px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 99;
}

.mid-filter {
  display: flex;
  align-items: space-between;
  position: relative;
  margin-bottom: 16px;
  // justify-content: space-between;
  padding: 16px;
  padding-right: 96px;
  border-radius: 8px;
  background-color: var(--bg-gray-1);
  flex-wrap: wrap;
  gap: 16px; // 垂直和水平间距都是16px
  // overflow: hidden;
  max-height: 86px; // 限制为一行的高度，不包括gap，因为第一行不会有gap
  transition: max-height 0.3s ease;

  &.expanded {
    max-height: none; // 展开时移除高度限制
    overflow: visible;
  }

  &-item {
    display: flex;
    flex-direction: column;
    // width: 20%;

    &.filter-item-hidden {
      display: none !important;
    }
  }

  //  &-item:first-child{
  //  width: 20%;
  //  }
  //  &-item:nth-child(2){
  //   width: 14%;
  //  }
  &-checkbox {
    background-color: var(--bg-gray-6);
    border-radius: 8px;
    height: 32px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    // justify-content: center;
  }

  &-title {
    font-size: 13px;
    font-weight: 600;
    height: 18px;
    // opacity: 0.7;
    letter-spacing: 0.3px;
    line-height: 18px;
    color: #0f0629;
    margin-bottom: 4px;
  }
}

.select-button-group {
  display: flex;
  align-items: center;
}

.select-product-button {
  &:before {
    // font-size: 20px;
    content: '\e77c';
    margin-right: 8px;
    font-family: 'iconfont';
  }
}

.select-exit {
  background-color: #835cf2;
  color: #fff !important;
  border-radius: 8px 0 0 8px !important;

  &:hover {
    border: 1px solid #835cf2 !important;
    background-color: #835cf2 !important;
    color: #fff !important;
  }

  &:before {
    // font-size: 20px;
    content: '\e744';
    margin-right: 8px;
    font-family: 'iconfont';
  }
}

.select-current-page-button {
  border-radius: 0 !important;
}

.actions-button {
  border-radius: 0 8px 8px 0 !important;

  background: #ffffff;
  border: 2px solid #9c7df5;
  box-shadow: 0 1px 0 0 #0f06290d;

  &:hover {
    border-radius: 0 8px 8px 0 !important;

    background: #ffffff;
    border: 2px solid #9c7df5;
    box-shadow: 0 1px 0 0 #0f06290d;
  }
}

@text-color: #6c3df2;

.select-divider {
  font-weight: 600;
  font-size: 20px;
}

// .actions-button-active{
//   background-color: var(--yellow-2) !important;
// }
.content-wrapper {
  display: flex;
}

.select-product {
  // border: 1px solid var(--primary);
  border: 2px solid #835cf2cc;
  box-shadow: 0 2px 0 0 #0f06290d;
}

.list {
  display: grid;
  grid-gap: 16px;
  margin-bottom: 16px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));

  &.single-page {
    margin-bottom: 40px;
  }

  .item-hover {
    &:hover {
      border-color: var(--border-1);
      background-color: var(--bg-gray-6);

      .title {
        color: var(--dark-1);
      }

      .get-link {
        display: block;
      }
    }
  }

  .item {
    overflow: hidden;
    position: relative;
    border-radius: 8px;
    // padding-bottom: 60px;
    text-decoration: none;
    background-color: var(--bg-gray-9);
  }

  .img-wrapper {
    height: 0;
    width: 100%;
    position: relative;
    text-align: center;
    padding-bottom: 80%;
    overflow: hidden;
  }

  .deal-sign,
  .upcoming {
    top: 3%;
    right: -40px;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    padding: 2px 20px;
    line-height: 12px;
    position: absolute;
    background: #fa9e00;
    transform: rotate(45deg);
  }

  .deal-sign {
    z-index: 1;
    height: 22px;
    padding: 0 40px;
    font-size: 13px;
    line-height: 22px;
    font-weight: normal;
    background-color: #f25544;
  }

  .img-bg {
    margin: 8px 8px 0;
    position: relative;
    border-radius: 6px;
    background: #fff;
    width: calc(100% - 16px);
    padding-bottom: calc(80% - 8px);
  }

  .logo {
    top: 50%;
    left: 50%;
    max-width: 100%;
    position: absolute;
    max-height: calc(100% - 16px);
    transform: translate(-50%, -50%);
  }

  .price {
    display: flex;
    color: #999;
    padding: 0 10px;
    font-size: 16px;
    margin-top: 10px;
    font-weight: 500;
    color: #0f0629;
    align-items: center;
    justify-content: space-between;

    >i {
      font-size: 14px;
      color: @text-color;
      font-style: normal;
    }

    >span {
      display: flex;
      align-items: center;
    }
  }

  // 元件
  .original {
    font-size: 13px;
    margin-left: 4px;
    color: var(--dark-3);
    font-weight: normal;
    text-decoration: line-through;
  }

  .title {
    height: 51px;
    padding: 0 10px;
    font-size: 13px;
    text-align: left;
    line-height: 17px;
    margin: 8px 0 3px;
    color: var(--dark-2);
    .multiple-ellipsis(3);
  }

  .priceOff {
    font-size: 13px;
    font-weight: 500;
    color: #f25544;
    padding-left: 10px;
    margin-bottom: -8px;
  }

  .star {
    width: 100%;
    height: 17px;
    display: flex;
    font-size: 12px;
    padding-left: 10px;
    align-items: center;
    color: var(--dark-3);
    letter-spacing: 0.34px;

    :deep(.ant) {
      &-rate {
        margin-top: -4px;
        margin-right: 8px;
        color: rgb(245, 166, 35, 0.8);

        &-star {
          &-zero .ant-rate-star-second {
            color: rgba(0, 0, 0, 0.15);
          }

          &-half {
            .ant-rate-star-second {
              color: rgba(0, 0, 0, 0.15);
            }
          }

          >div {
            font-size: 12px;
          }

          &:not(:last-child) {
            margin-inline-end: 2px;
          }
        }
      }
    }
  }

  .place-bottom {
    padding: 0 10px;
    margin: 14px 0;
    cursor: pointer;

    // bottom: 12px;
    // position: absolute;
    .place-bottom-img {
      width: 65px;
      height: 16px;
      margin-right: 12px;
    }

    // .place-bottom-item:first-child {
    //   margin-bottom: 12px;
    // }

    .place-bottom-item {
      display: flex;
      align-items: center;

      padding: 9px 0;

      .item-title {
        color: #0f0629;
        font-family: 'Sora';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        letter-spacing: 0.3px;
        opacity: 0.5;
      }

      .item-text {
        color: #794ff2;
        font-family: 'Sora';
        font-size: 13px;
        font-style: normal;
        font-weight: 600;

        letter-spacing: 0.3px;
      }

      .symbol {
        color: #0f06294d;
        font-family: 'Sora';
        font-size: 13px;
        font-style: normal;
        font-weight: 500;

        letter-spacing: 0.3px;
        margin: 0 5px;
      }

      .item-currency {
        color: #e68200;
        font-family: 'Sora';
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 0.3px;
      }
    }
  }

  .commission,
  .est-payout {
    height: 18px;
    font-size: 13px;
    line-height: 18px;
    padding-left: 10px;
    color: var(--dark-3);

    >i {
      font-weight: 500;
      font-style: normal;
      letter-spacing: 0.3px;
    }
  }

  .commission>i {
    color: @text-color;
  }

  .est-payout {
    margin-top: 2px;

    >i {
      color: var(--yellow-4);
    }
  }

  .get-link {
    left: 8px;
    right: 8px;
    bottom: 0px;
    height: 33px;
    display: none;
    cursor: pointer;
    line-height: 33px;
    position: absolute;
    text-align: center;
    border-radius: 4px;
    color: var(--color-white);
    background: var(--primary);
    box-shadow: 0 1px 0 0 var(--box-shadow-1);
  }
}

.left-filter {
  flex: 0 0 215px;
  margin-right: 20px;

  .item {
    &:last-of-type {
      margin-bottom: 16px;
    }
  }

  .price {
    margin-bottom: 20px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  h3 {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    margin-bottom: 10px;

    >.iconfont {
      width: auto;
      height: auto;
      color: var(--dark-3);

      &.icon-henggang-jiacu,
      &.icon-jiahao-cu {
        flex: 1;
        text-align: right;
      }
    }

    .icon-jiantou-zuo-cu {
      width: 16px;
      height: 16px;
      font-size: 14px;
      line-height: 16px;
      margin-right: 4px;
      color: var(--dark-2);
    }
  }

  .categories>h3 {
    cursor: pointer;
  }

  .category-tree {
    margin-left: 10px;
  }

  .brands-list {
    margin-top: 6px;
    overflow-y: auto;
    max-height: 187px;
  }

  .loading-more {
    display: flex;
    font-size: 12px;
    margin-top: 2px;
    align-items: center;
    justify-content: center;

    .ant-spin-text {
      margin-left: 6px;
    }
  }

  .brand-item {
    width: 200px;
    height: 30px;
    display: flex;
    line-height: 30px;
    font-weight: normal;

    &:hover,
    &.ant-checkbox-wrapper-checked {
      color: @text-color;
    }

    :deep(> span:last-of-type) {
      overflow: hidden;
      white-space: nowrap;
      padding-inline-end: 0;
      text-overflow: ellipsis;
      flex: 0 0 calc(100% - 16px);
    }
  }

  .seperates {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--border-4);
  }
}

.right-content {
  flex: 1;

  // .top{
  //   position: sticky;
  //   top: 0;
  //   z-index: 10;
  //   background-color: #fff;
  // }
  h2 {
    display: flex;
    font-size: 20px;
    line-height: 25px;
    align-items: center;
    margin-right: -15px;
    padding-right: 15px;
    padding-bottom: 12px;
    justify-content: space-between;
    border-bottom: 1px solid #e8e5ed;
  }

  :deep(.ant) {
    &-pagination {
      text-align: right;
      margin-bottom: 20px;
      justify-content: right;
    }
  }

  .country {
    margin-top: -4px;
  }
}

.top-filter {
  display: flex;
  margin: 16px 0;
  align-items: center;
  justify-content: space-between;

  .flex-left,
  .flex-right {
    display: flex;
    align-items: center;

    .flex-right-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      margin-left: 16px;
    }
  }

  .search {
    width: 180px;
    margin-left: 8px;
  }
}

.filter-list {
  .ant-tag {
    height: 32px;
    padding: 0 12px;
    font-size: 14px;
    line-height: 32px;
    margin-right: 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    background: var(--bg-gray-8);
  }

  :deep(.ant-segmented-item) {
    min-width: auto;
  }

  :deep(.ant) {
    &-tag-close-icon {
      font-size: 12px;
      margin-left: 9px;
      margin-right: -4px;
    }
  }

  .reset-filter {
    cursor: pointer;
    margin-right: 0;
    background: none;
    color: var(--primary-text);

    >em {
      font-weight: 600;
      font-style: normal;
    }
  }
}
</style>
